module.exports = __webpack_public_path__ + "img/smart1.02450348.svg";